export const layoutContentMarginTop = {
  mobile: 56,
  nonMobile: 64,
};
